import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyboardIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		id: "background",
		width: 64,
		height: 64,
		fill: "transparent"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "keyboard",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "rect",
				d: "M2 19.5C2 17.8432 3.34315 16.5 5 16.5H59C60.6569 16.5 62 17.8432 62 19.5V43.5C62 45.1569 60.6569 46.5 59 46.5H5C3.34315 46.5 2 45.1569 2 43.5V19.5Z",
				stroke: "black",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "backspace",
				d: "M6.59952 21.0995C6.39859 21.3005 6.28571 21.573 6.28571 21.8571V24C6.28571 24.2842 6.39859 24.5567 6.59952 24.7576C6.80045 24.9585 7.07297 25.0714 7.35713 25.0714H13.7857C14.0699 25.0714 14.3424 24.9585 14.5433 24.7576C14.7443 24.5567 14.8571 24.2842 14.8571 24V21.8571C14.8571 21.573 14.7443 21.3005 14.5433 21.0995C14.3424 20.8986 14.0699 20.7857 13.7857 20.7857H7.35713C7.07297 20.7857 6.80045 20.8986 6.59952 21.0995Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "enter",
				d: "M40.8853 29.671C40.6843 29.8719 40.5714 30.1444 40.5714 30.4286V32.5714C40.5714 32.8556 40.6843 33.1281 40.8853 33.329C41.0862 33.53 41.3587 33.6429 41.6429 33.6429H48.0714C48.3556 33.6429 48.6281 33.53 48.8291 33.329C49.03 33.1281 49.1429 32.8556 49.1429 32.5714V30.4286C49.1429 30.1444 49.03 29.8719 48.8291 29.671C48.6281 29.47 48.3556 29.3571 48.0714 29.3571H41.6429C41.3587 29.3571 41.0862 29.47 40.8853 29.671Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "space",
				d: "M15.171 38.2424C14.97 38.4433 14.8571 38.7158 14.8571 39V41.1429C14.8571 41.427 14.97 41.6995 15.171 41.9005C15.3719 42.1014 15.6444 42.2143 15.9286 42.2143H39.5C39.7842 42.2143 40.0567 42.1014 40.2576 41.9005C40.4586 41.6995 40.5714 41.427 40.5714 41.1429V39C40.5714 38.7158 40.4586 38.4433 40.2576 38.2424C40.0567 38.0415 39.7842 37.9286 39.5 37.9286H15.9286C15.6444 37.9286 15.3719 38.0415 15.171 38.2424Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r1",
				d: "M27.7143 21.0357C27.7143 20.8976 27.8262 20.7857 27.9643 20.7857H31.75C31.8881 20.7857 32 20.8976 32 21.0357V24.8214C32 24.9595 31.8881 25.0714 31.75 25.0714H27.9643C27.8262 25.0714 27.7143 24.9595 27.7143 24.8214V21.0357Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r11",
				d: "M23.4286 29.6071C23.4286 29.4691 23.5405 29.3571 23.6786 29.3571H27.4643C27.6023 29.3571 27.7143 29.4691 27.7143 29.6071V33.3929C27.7143 33.5309 27.6023 33.6429 27.4643 33.6429H23.6786C23.5405 33.6429 23.4286 33.5309 23.4286 33.3929V29.6071Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r12",
				d: "M14.8571 29.6071C14.8571 29.4691 14.9691 29.3571 15.1071 29.3571H18.8929C19.0309 29.3571 19.1429 29.4691 19.1429 29.6071V33.3929C19.1429 33.5309 19.0309 33.6429 18.8929 33.6429H15.1071C14.9691 33.6429 14.8571 33.5309 14.8571 33.3929V29.6071Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r13",
				d: "M6.28571 29.6071C6.28571 29.4691 6.39763 29.3571 6.53571 29.3571H10.3214C10.4595 29.3571 10.5714 29.4691 10.5714 29.6071V33.3929C10.5714 33.5309 10.4595 33.6429 10.3214 33.6429H6.53571C6.39763 33.6429 6.28571 33.5309 6.28571 33.3929V29.6071Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r14",
				d: "M6.28571 38.1786C6.28571 38.0405 6.39763 37.9286 6.53571 37.9286H10.3214C10.4595 37.9286 10.5714 38.0405 10.5714 38.1786V41.9643C10.5714 42.1024 10.4595 42.2143 10.3214 42.2143H6.53571C6.39763 42.2143 6.28571 42.1024 6.28571 41.9643V38.1786Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r15",
				d: "M44.8571 38.1786C44.8571 38.0405 44.9691 37.9286 45.1071 37.9286H48.8929C49.0309 37.9286 49.1429 38.0405 49.1429 38.1786V41.9643C49.1429 42.1024 49.0309 42.2143 48.8929 42.2143H45.1071C44.9691 42.2143 44.8571 42.1024 44.8571 41.9643V38.1786Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r4",
				d: "M36.2857 21.0357C36.2857 20.8976 36.3976 20.7857 36.5357 20.7857H40.3214C40.4595 20.7857 40.5714 20.8976 40.5714 21.0357V24.8214C40.5714 24.9595 40.4595 25.0714 40.3214 25.0714H36.5357C36.3976 25.0714 36.2857 24.9595 36.2857 24.8214V21.0357Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r10",
				d: "M32 29.6071C32 29.4691 32.1119 29.3571 32.25 29.3571H36.0357C36.1738 29.3571 36.2857 29.4691 36.2857 29.6071V33.3929C36.2857 33.5309 36.1738 33.6429 36.0357 33.6429H32.25C32.1119 33.6429 32 33.5309 32 33.3929V29.6071Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r5",
				d: "M44.8571 21.0357C44.8571 20.8976 44.9691 20.7857 45.1071 20.7857H48.8929C49.0309 20.7857 49.1429 20.8976 49.1429 21.0357V24.8214C49.1429 24.9595 49.0309 25.0714 48.8929 25.0714H45.1071C44.9691 25.0714 44.8571 24.9595 44.8571 24.8214V21.0357Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r6",
				d: "M53.4286 21.0357C53.4286 20.8976 53.5405 20.7857 53.6786 20.7857H57.4643C57.6023 20.7857 57.7143 20.8976 57.7143 21.0357V24.8214C57.7143 24.9595 57.6023 25.0714 57.4643 25.0714H53.6786C53.5405 25.0714 53.4286 24.9595 53.4286 24.8214V21.0357Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r7",
				d: "M53.4286 29.6071C53.4286 29.4691 53.5405 29.3571 53.6786 29.3571H57.4643C57.6023 29.3571 57.7143 29.4691 57.7143 29.6071V33.3929C57.7143 33.5309 57.6023 33.6429 57.4643 33.6429H53.6786C53.5405 33.6429 53.4286 33.5309 53.4286 33.3929V29.6071Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r8",
				d: "M53.4286 38.1786C53.4286 38.0405 53.5405 37.9286 53.6786 37.9286H57.4643C57.6023 37.9286 57.7143 38.0405 57.7143 38.1786V41.9643C57.7143 42.1024 57.6023 42.2143 57.4643 42.2143H53.6786C53.5405 42.2143 53.4286 42.1024 53.4286 41.9643V38.1786Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "r3",
				d: "M19.1429 21.0357C19.1429 20.8976 19.2548 20.7857 19.3929 20.7857H23.1786C23.3166 20.7857 23.4286 20.8976 23.4286 21.0357V24.8214C23.4286 24.9595 23.3166 25.0714 23.1786 25.0714H19.3929C19.2548 25.0714 19.1429 24.9595 19.1429 24.8214V21.0357Z",
				fill: "black"
			})
		]
	})]
});
export default SvgKeyboardIcon;
